import { OfferType } from '@dgx-pr-spa/shared/util';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-another-look-container',
  templateUrl: './another-look-container.component.html',
  styleUrls: ['./another-look-container.component.scss'],
})
export class AnotherLookContainerComponent {
  constructor(public viewOffersService: ViewOffersService) {}
  /**
   * Emits a click event from the show more CTA to parent
   */
  @Output() showMoreClicked: EventEmitter<OfferType> = new EventEmitter();

  /**
   * Emit array of the selected offers sibling
   */
  @Output() comparisonClicked: EventEmitter<ReplacementOffer[]> =
    new EventEmitter();

  /**
   * Emit click event from sibling
   */
  @Output() cardClicked: EventEmitter<ReplacementOffer> = new EventEmitter();

  /**
   * Receives an array of offers to be displayed
   */
  @Input() replacementOffers = [] as ReplacementOffer[];

  /**
   * RRPFlag value for the current product
   */
  @Input() rrpFlag: boolean;

  /**
   * Observable of the comparisons selected
   */
  comparisons$ = this.viewOffersService.comparisons$;

  /**
   * onShowMoreClick
   */
  onShowMoreClick(event) {
    this.showMoreClicked.emit(event);
  }

  /**
   * Fire emit of selected offers
   */
  onComparisonClick(offer: ReplacementOffer[]) {
    this.comparisonClicked.emit(offer);
  }
  /**
   * Carry emitted click event from sibling
   */
  onCardClick(event: ReplacementOffer) {
    this.cardClicked.emit(event);
  }
}
